import React, { useEffect, useState } from "react";
// import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
// import backicon from './../../../../../../Assets/icons/backIcon.svg';
import backicon from "../../../../../Assets/icons/backIcon.svg";
// import "./index.scss";
import { useLocation, useNavigate } from "react-router-dom";
// import ROUTES_NAVIGATION from "../../../../../../routes/routes";
// import axiosInstance from "../../../../../services/api/API";
// import Loader from "../../../../../customComponents/CustomLoader";
import Swal from "sweetalert2";
import ROUTES_NAVIGATION from "../../../../../routes/routes";
import axiosInstance from "../../../../services/api/API";
import Loader from "../../../../customComponents/CustomLoader";
import DynamicForm from "../../../../customformComponent/customForm/DynamicForm";

const AddEngineer = () => {
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const navigate = useNavigate();
  // const authToken = localStorage.getItem("authToken");
    const authToken = sessionStorage.getItem("u_t");
  const [userTypedd, setUserTypedd] = useState([]);
  const [roledd, setRoledd] = useState([]);

  const [dealerOptions, setDealerOptions] = useState([]);

  const userType = localStorage.getItem("UserType");
  console.log(userType, "USERTYPE");
  const businessPartnerId = localStorage.getItem("business_partner_id");

  useEffect(() => {
    fetchDealers();
  }, []);

  const fetchDealers = async () => {
    try {
      const response = await axiosInstance.post("/dealer/ddldealer", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = response?.data?.data?.data;

      const dealerOptions = data.map((dealer) => ({
        value: dealer.dealer_id,
        label: dealer.dealer_name,
      }));

      setDealerOptions(dealerOptions);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    userTypedropdown();
  }, []);

  const userTypedropdown = async () => {
    try {
      const response = await axiosInstance.get("/bp-onboard/bplist", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = response.data.data.data;
      const userTypeOptions = data.map((user) => ({
        value: user.onboard_id,
        label: user.bp_name,
      }));
      setUserTypedd(userTypeOptions);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    roleDropdown();
  }, []);

  const roleDropdown = async () => {
    try {
      const payload = {
        business_partner_id:
          userType === "superadmin"
            ? formData?.business_partner_id
            : businessPartnerId,
      };

      const response = await axiosInstance.post("/role/ddlrole", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = response.data.data.data;
      const roleOptions = data.map((role) => ({
        value: role.ID,
        label: role.NAME,
      }));
      setRoledd(roleOptions);
    } catch (error) {
      console.log(error);
    }
  };

  const handleFormSubmit = async (formData) => {
    console.log("engineerFormData", formData);

    const errors = {};
    let isValid = true;

    DealerInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        } else if (
          field.validation.pattern &&
          !field.validation.pattern.test(formData[field.name])
        ) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to add this engineer?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setLoading(true);
          const payload = {
            // dealer_id: formData.dealer_id,
            dealer_id: Array.isArray(formData.dealer_id)
              ? formData.dealer_id.join(",")
              : "",
            engineer_name: formData.engineer_name,
            engineer_desc: formData.engineer_desc,
            contact_no: formData.contact_no,
            engineer_address: formData.engineer_address,
            email_id: formData.email_id,
            tin: formData.tin,
            pan: formData.pan,
            gst: formData.gst,
            country_id: formData.country_id,
            state_id: formData.state_id,
            city_id: formData.city_id,
            engineer_pin_code: formData.pincode,
            password: formData?.password,
            role_id: formData.role_id,
            status: formData.status === true ? 1 : 0,
          };

          // API call to create a dealer
          const response = await axiosInstance.post(
            "/engineer/create",
            payload,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${authToken}`,
              },
            }
          );

          if (response.status === 200) {
            Swal.fire({
              title: "Success",
              text: "Engineer added successfully!",
              icon: "success",
              confirmButtonText: "OK",
            }).then(() => {
              navigate("/admin/manage-engineer/engineer");
            });
          }
        } catch (error) {
          console.error("Error adding engineer:", error);
          const errorMessage =
            error.response?.data?.message ||
            "An error occurred while processing your request.";
          Swal.fire({
            title: "Error",
            text: errorMessage,
            icon: "error",
            confirmButtonText: "OK",
          });
        } finally {
          setLoading(false);
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire({
          title: "Cancelled",
          text: "The engineer was not added.",
          icon: "info",
          confirmButtonText: "OK",
        });

        setLoading(false);
      }
    });
  };

  useEffect(() => {
    const generateRandomPassword = (length = 10) => {
      const chars =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()";
      let password = "";
      for (let i = 0; i < length; i++) {
        password += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return password;
    };

    const randomPassword = generateRandomPassword();

    setFormData((pre) => ({
      ...pre,
      password: randomPassword,
    }));
  }, []);

  const DealerInputs = [
    {
      name: "dealer_id",
      label: "Dealer",
      type: "multiselectdropdown",
      required: true,
      options: dealerOptions,
      gridClass: "col-lg-4",
    },
    {
      name: "engineer_name",
      label: "Engineer Name",
      placeholder: "Enter Engineer Name",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: {
        required: true,
        pattern: /^[A-Za-z\s]*$/,
        message: "Only Alphabets Are Allowed*",
      },
    },

    {
      name: "contact_no",
      label: "Contact No.",
      placeholder: "Enter Contact No.",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: {
        required: true,
        pattern: /^[6-9]/,
        minLength: 10,
        maxLength: 10,
        message1: "Contact No. should start with 6, 7, 8, 9",
        message: "Please enter a valid 10-digit Contact No.",
      },
    },
    {
      name: "engineer_address",
      label: "Engineer Address",
      placeholder: "Enter Engineer Address",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "email_id",
      label: "Email ID",
      placeholder: "Enter Email Address",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: {
        required: true,
        pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        message: "Please enter a valid Email Address",
      },
    },
    {
      name: "password",
      label: "Password",
      placeholder: "Enter Password",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "pan",
      label: "PAN No.",
      type: "text",
      placeholder: "Enter Pan No.",
      validation: {
        // required: true,
        pattern: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
        message: "Please enter a valid 10-character PAN number",
        maxLength: 10,
      },
      // required: true,
      gridClass: "col-lg-4",
    },
    // {
    //   name: "gst",
    //   label: "GST No.",
    //   type: "text",
    //   placeholder: "Enter GST No.",
    //   validation: {
    //     // required: true,
    //     pattern: /^\d{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}Z[A-Z0-9]{1}$/,
    //     message: "Please enter a valid 15-character GST number",
    //     maxLength: 15
    //   },
    //   // required: true,
    //   gridClass: "col-lg-4",
    // },
    {
      name: "pincode",
      label: "Pin Code",
      placeholder: "Enter Pin Code",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true, maxLength: 6 },
    },
    {
      name: "city",
      label: "City",
      placeholder: "City",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      // validation: { required: true },
      disabled: true,
    },
    {
      name: "state",
      label: "State",
      placeholder: "State",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      // validation: { required: true },
      disabled: true,
    },
    {
      name: "country",
      label: "Country",
      placeholder: "Country",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      // validation: { required: true },
      disabled: true,
    },
    // {
    //   name: "role_id",
    //   label: "Role",
    //   type: "dropdown",
    //   options: roledd,
    //   required: true,
    //   gridClass: "col-lg-4",
    //   validation: { required: true },
    // },
    {
      name: "status",
      label: "Status",
      type: "toggle",
      required: true,

      // validation: { required: true },
    },
    // {
    //   name: "actions",
    //   label: "Actions",
    //   type: "multiselectdropdown",
    //   required: true,
    //   options: [
    //     { label: "Edit", value: "Edit" },
    //     { label: "Delete", value: "Delete" },
    //   ],
    //   gridClass: "col-lg-4",
    // },
  ];

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="backbutton mt-2 mb-2" onClick={() => navigate(-1)}>
            <img src={backicon} alt="back" />
            <span className="backbtntitle">Add New Engineer</span>
          </div>
          <div className="form-container">
            <span className="cust-det-title mt-2 mb-2">
              Please Enter Engineer Details
            </span>
            <DynamicForm
              formConfig={DealerInputs}
              formData={formData}
              setFormData={setFormData}
              onSubmit={handleFormSubmit}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
            />
          </div>
          <div className="btncontainer mt-3">
            <button
              onClick={() => {
                handleFormSubmit(formData);
              }}
              className="submit-btn"
            >
              Submit
            </button>
          </div>
        </>
      )}
    </>
  );
};

export default AddEngineer;
